import React from 'react'
import { useTranslation } from 'react-i18next'
import { IVehicleProperty } from '@cbgms/api/modules/vehicles'
import { Table, TableBody, TableCell, TableRow } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import RemarkLabel from 'app/vehicles/components/Details/External/RemarkLabel'

const useStyles = makeStyles(theme => ({
  chip: { display: 'flex', justifyContent: 'flex-end', marginTop: theme.spacing() },
  cell: { minWidth: '7rem' }
}))

const RegisteredInformation: React.FC<{
  provider: string | undefined
  vehiclePropertiesAsTableRows: (IVehicleProperty | undefined)[][] | undefined | null
}> = ({ provider, vehiclePropertiesAsTableRows }) => {
  const { t } = useTranslation()
  const styles = useStyles()

  return (
    <div className='w100'>
      <Table size='small'>
        <TableBody>
          {vehiclePropertiesAsTableRows!.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {row.map((cellPair, cellPairIndex) => (
                <React.Fragment key={cellPairIndex}>
                  <TableCell className={styles.cell}>
                    <strong>{cellPair?.Key}</strong>
                  </TableCell>
                  <TableCell className={styles.cell}>{cellPair?.Value}</TableCell>
                </React.Fragment>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div className={styles.chip}>
        <RemarkLabel text={`${t('vehicle_registered_information.modal.provided_by')} ${provider}`} />
      </div>
    </div>
  )
}

export default RegisteredInformation
